export default __webpack_public_path__ + "static/media/FelixCh10.bba85cc0.svg";